'use strict';

import charts from './chartist';

export default function routes($stateProvider) 
{
	'ngInject';
	
	$stateProvider
	.state("CommonResults", { 
		url: "/res/{event:int}",
		abstract:true,
		template: require("./result_common.html"), 
		controller: 'ResultCommonController',
		controllerAs: 'vm'
	})
	// Evento (sin carrera). Se redirigirá a la ruta evento/carrera correspondiente (estado Summary)
	.state("CommonResults.Event", { 
		url: "",
		template: require("./result_summary.html"), 
		controller: function ($scope)
		{
			//console.log("Event controller");
			//console.log("EVENT: " + $stateParams.event);
			// Desde aqui simplemente redirigimos a la primera categoria

			$scope.vm.RedirectToFirstRace();
			//$state.go("CommonResults.Summary", {class: 1});
		},
		controllerAs: 'vm'
	})
	// Summay of a race
	.state("CommonResults.Summary", { 
		url: "/{race:int}",
		template: require("./result_summary.html"), 
		controller: function($scope, $state, $stateParams, $log, $http)
		{
			//console.log("--SUMMARY");
			$scope.vm.SelectNodeFromStateParams($stateParams);

			$scope.viewPromise = $http.post("/api/frontend/results/" + $stateParams.event + "/" + $stateParams.race)
			.then(response =>
			{
				$scope.race = response.data;
				//console.log("SUMMARY: race");
				//console.log(response.data);
			});
		},
		controllerAs: 'vm'
	})
	// Session result
	.state("CommonResults.Session", { 
		url: "/{race:int}/{session:int}", 
		template: require("./result_session.html"), 
		controller: function ($scope, $state, $stateParams, $log, $http)
		{
			//console.log("--SESSION");
			$scope.vm.SelectNodeFromStateParams($stateParams);
			/*
			console.log("- Event " + $stateParams.event);
			console.log("- Raceresult " + $stateParams.race);
			console.log("- Sessionresult " + $stateParams.session);*/

			$scope.viewPromise = $http.post("/api/frontend/results/" + $stateParams.event + "/" + $stateParams.race + "/" + $stateParams.session)
			.then(response =>
			{
				$scope.eventId = $stateParams.event;
				$scope.raceId = $stateParams.race;
				$scope.session = response.data;
				//console.log("SESSION loaded");
				//console.log(response.data);
			});
		},
		controllerAs: 'vm'
	})
	// Round results
	.state("CommonResults.Round", { 
		url: "/{race:int}/{session:int}/{round:int}", 
		template: require("./result_round.html"),
		controller: function ($scope, $state, $stateParams, $log, $http)
		{
			//console.log("--ROUND");
			$scope.vm.SelectNodeFromStateParams($stateParams);

			$scope.viewPromise = $http.post("/api/frontend/results/" + $stateParams.event + "/" + $stateParams.race + "/" + $stateParams.session + "/" + $stateParams.round)
			.then(response =>
			{
				$scope.round = response.data;
				//console.log("ROUND loaded");
				//console.log(response.data);
			});
		},
		controllerAs: 'vm'
	})
	// Heat result
	.state("CommonResults.Heat", { 
		url: "/{race:int}/{session:int}/{round:int}/{serie:int}", 
		template: require("./result_heat.html"), 
		controller: function ($scope, $state, $stateParams, $log, $http)
		{
			//console.log("--HEAT");
			$scope.vm.SelectNodeFromStateParams($stateParams);

			$scope.viewPromise = $http.post("/api/frontend/results/" + $stateParams.event + "/" + $stateParams.race + "/" + $stateParams.session + "/" + $stateParams.round + "/" + $stateParams.serie)
			.then(response =>
			{
				$scope.getMaxLaps = function() {
					return new Array(response.data.maxLaps);
				}

				//console.log("HEAT loaded");
				$scope.heat = response.data;
				charts(response.data);
			});
		},
		controllerAs: 'vm'
	})
	// Driver summary
	//.state("CommonResults.Driver", { 
	.state("driverstats", {
		//url: "/{race:int}/d={driver:int}",
		url: "/res/{event:int}/{race:int}/d={driver:int}",
		template: require("./result_driver.html"),
		controller: function ($scope, $state, $stateParams, $log, $http)
		{
			$scope.viewPromise = $http.post("/api/frontend/results/" + $stateParams.event + "/" + $stateParams.race + "/d=" + $stateParams.driver)
			.then(response =>
			{
				$scope.vm = response.data;
				//console.log(response.data);
				//$scope.vm.comparisonDriver = "";
				$scope.vm.ChangeDriver = function ()
				{
					var id = $scope.vm.comparisonDriver;
					if (!id || id === "") id = 0;
					
					$http.post("/api/frontend/results/" + $stateParams.event + "/" + $stateParams.race + "/comparison/" + $stateParams.driver + "/" + id)
					.then(response =>
					{
						//console.log(response.data);
						$scope.vm.drivercomparison = response.data.drivercomparison;
					});
				}

				// Force first call
				$scope.vm.ChangeDriver();

				//console.log("DRIVER loaded");
				//console.log(data);

				$scope.vm.flattenedHeats = [];
				for (let x of $scope.vm.sessions)
				{
					for (let h of x.heats)
					{
						h.sessionid = x.id;
						h.countfirstlap = x.countfirstlap;
					}
					
					$scope.vm.flattenedHeats = $scope.vm.flattenedHeats.concat(x.heats);
				}
			});
		},
		controllerAs: 'vm'
	})
	// User stats
	.state("userstats", { 
		url: "/us", ///{driver:int}", 
		template: require("../../common/notavailable.html"),
		controller: 'UserStatsController',
		controllerAs: 'vm'
	})
	.state('stats', {
		url: '/stats',
		template: require("./stats.html"),
		controller: function($http, $scope)
		{
			$http.post('/api/frontend/results/stats')
			.then(response =>
			{
				//console.log(response.data);
				$scope.stats = response.data;
			});
		}
	})
	.state('resultdata_redirect', {
		url: '/resultdata',
		controller: function($location)
		{
			// http://localhost:3000/resultdata#452/687
			window.location = "/res/" + $location.hash();
		}
	});
}



/*		
// when there is an empty route, redirect to /index   
$urlRouterProvider.when('/resultdata', ['$match', '$stateParams', function ($match, $stateParams) {
	console.log(JSON.stringify($match));	
	console.log(JSON.stringify($stateParams));
}]);

// You can also use regex for the match parameter
$urlRouterProvider.when("/aspx/*", '/ev/*');

	$urlRouterProvider.rule(function ($injector, $location) {
//what this function returns will be set as the $location.url
var path = $location.path(), normalized = path.toLowerCase();
if (path != normalized) {
	//instead of returning a new url string, I'll just change the $location.path directly so I don't have to worry about constructing a new url string and so a new state change is not triggered
	$location.replace().path(normalized);
	console.log($location.path());
	console.log($location);
}
// because we've returned nothing, no state change occurs
);
*/



// WEBPACK FOOTER //
// ./client/app/frontend/results/results.routes.js